// extracted by mini-css-extract-plugin
export default {"fake-button":"p1FnZ","fakeButton":"p1FnZ"};